import React from "react";
import useFetch from "../../hooks/useFetch";
import { Anchor } from "antd";

const List = ({ items }) => {
  return (
    <ul className="px-6 py-4 space-y-3">
      {
        items && items.map((item) => {
          const { id, url, title, content } = item
          const transUrl = url.startsWith('https') ? url : 'https://' + url
          return (
            <li className="min-h-[100px] rounded-md" key={id}>
              <div className="flex flex-col px-8 py-2 h-full">
                <h3 className="text-2xl">{title}</h3>
                <div className="flex justify-between items-end">
                  <p className="text-md w-[900px] p-2">
                    {content}
                  </p>
                  <a
                    href={transUrl}
                    target="_blank"
                  >
                    <span className="text-[16px] w-24 bg-yellow-400 flex flex-1 items-center justify-center px-2 py-1 rounded-md hover:bg-sky-400 transition-all duration-300">了解更多 </span>
                  </a>
                </div>
              </div>
            </li>
          )
        })
      }
    </ul>
  )
}

const Item = ({ name }) => {
  return (
    <div className="flex flex-col items-center my-72">
      <h3 className="text-4xl my-8 font-semibold" id={name.key}>{name.name}</h3>
      <div className="w-1/2 bg-slate-100 rounded-md">
        <List items={name.data} />
      </div>
    </div>
  )
}

const Tech = () => {
  const d = useFetch('http://1.94.62.64:9090/myf/technologyFrontier')

  const nameArr = [{
    key: 'wechat',
    name: '微信',
    data: d?.wechat
  },
  {
    key: 'tiktok',
    name: '抖音',
    data: d?.tiktok
  }].filter((item, idx) => item.name === d?.[item.key]?.[idx].name)

  return (
    <div className="my-[200px] relative">
      <div className="absolute left-[300px]">
        <Anchor
          items={nameArr.map((name) => {
            return {
              key: `${name.key}`,
              href: `#${name.key}`,
              title: <span className="text-xl">{name.name}</span>,
            }
          })}
        />
      </div>
      {
        nameArr.map((name) => {
          return <Item key={name} name={name} d={d} />
        })
      }
    </div>
  );
};

export default Tech;
